// Seleção múltipla do filtro de projeto do Dashboard.
// Convenção: lista vazia = sem filtro de projeto (nenhum marcado ou todos marcados).

export interface ProjetoOpcao {
  uid_pesca_projeto: string;
  nome: string;
}

/** Nenhum marcado ou todos marcados viram [] (sem filtro); caso contrário, mantém só os marcados. */
export function normalizarSelecaoProjetos(marcados: Iterable<string>, todos: string[]): string[] {
  const unicos = Array.from(new Set(marcados));
  if (unicos.length === 0) return [];
  const universo = new Set(todos);
  if (universo.size > 0 && universo.size === unicos.length && unicos.every((u) => universo.has(u))) return [];
  return unicos;
}

/** "Todos os projetos", o nome do projeto (se só um) ou "N projetos". */
export function rotuloProjetos(selecionados: string[], projetos: ProjetoOpcao[]): string {
  if (selecionados.length === 0) return 'Todos os projetos';
  if (selecionados.length === 1) return projetos.find((p) => p.uid_pesca_projeto === selecionados[0])?.nome || '1 projeto';
  return `${selecionados.length} projetos`;
}

/** Valor do parâmetro de query (uid_pesca_projetos=a,b); null quando não há filtro. */
export function paramProjetos(selecionados: string[]): string | null {
  return selecionados.length ? selecionados.join(',') : null;
}
